// DemoImpersonationBanner — 'Entrar como demo' (jun-2026, mandato founder).
// Barra fija superior mientras el founder navega la app como uno de sus
// barberos demo. Única vía de retorno: el botón "Volver a mi cuenta".
// El header X-Demo-User lo añade api.js desde localStorage; el backend solo
// lo respeta con identidad real super_admin/founder sobre cuentas is_demo.
import { UserRound, Undo2 } from 'lucide-react';
import { tr } from '@/contexts/LanguageContext';

export const demoImpersonation = {
  get() {
    try {
      const id = localStorage.getItem('lineage_demo_user');
      const username = localStorage.getItem('lineage_demo_username');
      return id ? { id, username } : null;
    } catch { return null; }
  },
  start(id, username) {
    try {
      localStorage.setItem('lineage_demo_user', id);
      localStorage.setItem('lineage_demo_username', username || 'demo');
    } catch { /* private mode */ }
    window.location.href = '/feed';
  },
  stop() {
    try {
      localStorage.removeItem('lineage_demo_user');
      localStorage.removeItem('lineage_demo_username');
    } catch { /* private mode */ }
    window.location.href = '/admin';
  },
};

export const DemoImpersonationBanner = () => {
  const demo = demoImpersonation.get();
  if (!demo) return null;
  return (
    <div
      data-testid="demo-impersonation-banner"
      className="fixed top-0 inset-x-0 z-[95] flex items-center justify-center gap-2 px-3 py-1.5"
      style={{
        background: 'rgba(12,10,6,0.9)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        borderBottom: '1px solid rgba(201,168,76,0.45)',
      }}
    >
      <UserRound className="w-3 h-3 flex-shrink-0" style={{ color: '#E5C169' }} />
      <span className="text-[10px] uppercase tracking-[0.14em] font-semibold"
        style={{ color: '#E5C169' }}>{tr("Viendo como @{0} (demo)", demo.username)}</span>
      <button
        type="button"
        onClick={demoImpersonation.stop}
        data-testid="demo-impersonation-exit"
        className="inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider"
        style={{ background: '#C9A84C', color: '#0C0A06' }}
      >
        <Undo2 className="w-3 h-3" />{' '}{tr("Volver a mi cuenta")}</button>
    </div>
  );
};

export default DemoImpersonationBanner;
